var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "px-2 w-100 page-card", attrs: { outlined: "" } },
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { staticClass: "pr-2", attrs: { large: "" } }, [
                _vm._v("mdi-account-details"),
              ]),
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("projectManagement")) +
                    " - " +
                    _vm._s(_vm.$t("permissionsAndAssignments"))
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "page-content" }, [
            _c(
              "div",
              { staticClass: "page-fixed" },
              [
                _c(
                  "v-row",
                  { staticClass: "mx-4", attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-autocomplete", {
                          staticStyle: { width: "80%" },
                          attrs: {
                            items: _vm.employees,
                            label: _vm.$t("selectUserHint"),
                            "item-text": "name",
                            color: "primary",
                            "return-object": "",
                          },
                          on: {
                            change: function ($event) {
                              _vm.mirroringActive = false
                              _vm.usersDataWithoutCurrentUser = []
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(data.item.name)),
                                      ]),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getUserTeamsAsString(
                                              data.item.teams
                                            )
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.selectedUser,
                            callback: function ($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "page-scroll" },
                      [
                        _c("v-select", {
                          staticClass: "mx-2",
                          attrs: {
                            items: _vm.teams,
                            "item-text": "name",
                            label: _vm.$t("selectDepartmentHint"),
                            color: "primary",
                          },
                          model: {
                            value: _vm.selectedTeam,
                            callback: function ($$v) {
                              _vm.selectedTeam = $$v
                            },
                            expression: "selectedTeam",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.selectedUser
                  ? _c(
                      "v-row",
                      { staticClass: "mt-0", attrs: { justify: "center" } },
                      [
                        _c("v-switch", {
                          staticClass: "mt-0 pt-0",
                          attrs: { label: _vm.$t("mirroringActive") },
                          model: {
                            value: _vm.mirroringActive,
                            callback: function ($$v) {
                              _vm.mirroringActive = $$v
                            },
                            expression: "mirroringActive",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.mirroringActive
                  ? _c("MirrorPermissions", {
                      staticClass: "mx-4",
                      attrs: {
                        selectedUser: _vm.selectedUser,
                        usersData: _vm.usersData,
                        usersDataWithoutCurrentUser:
                          _vm.usersDataWithoutCurrentUser,
                      },
                      on: { mirroringUpdate: _vm.handleMirroringUpdate },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "page-scroll" },
              [
                _vm.selectedUser
                  ? _c("ProjectStages", {
                      attrs: { selectedUser: _vm.selectedUser },
                      on: { updatedProject: _vm.handleStageUpdate },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }